import React from 'react'

export default function BottomTabNav({ props, currentStep, data, handler }) {
    const handleNext = () => {
        props.goToStep(currentStep + 1)
        handler(data)
    }
    const handleBack = () => { props.goToStep(currentStep - 1) }
    return (
        <div className="row mt-2">
            <div className="col-lg-12 justify-content-end">
                <button
                    type="button"
                    className="btn btn-primary float-right mr-2 "
                    onClick={handleNext}
                >
                    Next
                </button>
                {
                    currentStep !== 1 ? (
                        <button
                            type="button"
                            className="btn btn-default float-right mr-2 "
                            onClick={handleBack}
                        >
                            Previous
                        </button>
                    ) : null
                }
            </div>
        </div>
    )
}
